<script>
  export default {
    props: {
      // 前景色
      color: {
        type: String,
        required: true
      },
      // 进度
      value: {
        type: Number,
        default: 6
      },
      // 进度环大小
      size: {
        type: Number,
        default: 48
      },
      // 圆环宽度
      strokeWidth: {
        type: Number,
        default: 4
      },
      // 底色
      layerColor: {
        type: String,
        default: '#EEEEEE'
      },
      // 中间文本
      text: {
        type: String
      }
    },
    computed: {
      borderWidth() {
        return this.strokeWidth + 'px';
      },
      circleSize() {
        return this.size + 'px';
      },
      halfCircleSize() {
        return this.size / 2 + 'px';
      },
      maskSize() {
        return (this.size - this.strokeWidth * 2) + 'px';
      }
    }
  }
</script>

<template>
  <!--背景圆-->
  <div class="circle" :style="{backgroundColor: color, width: circleSize, height: circleSize}">
    <!--左半边圆-->
    <div class="circle-left"
         :style="{width: circleSize, height: circleSize, backgroundColor: value === 0 || value === 100 ? color : layerColor, transform : value > 50 ? 'rotate(' + ((value-50) * 3.6) + 'deg)':'', clip: 'rect(0, ' +  halfCircleSize + ', auto, 0)'}">
      <div class="clip-left" :style="{width: circleSize, height: circleSize, clip: 'rect(0, ' +  halfCircleSize + ', auto, 0)'}"/>
    </div>
    <!--右半边圆-->
    <div class="circle-right"
         :style="{width: circleSize, height: circleSize, backgroundColor: value === 0 || value === 100 || value > 50 ? color : layerColor, transform : value <= 50 ? 'rotate(' + (value * 3.6) + 'deg)' : 'rotate(0deg)', clip: 'rect(0, auto, auto, ' + halfCircleSize + ')'}">
      <div class="clip-right" :style="{width: circleSize, height: circleSize, clip: 'rect(0, auto, auto, ' + halfCircleSize + ')'}"/>
    </div>
    <div class="mask" :style="{width: maskSize, height: maskSize, lineHeight: maskSize, color: color, fontSize: value > 0 && value < 100 ? '12px': '10px', top: borderWidth, left: borderWidth}">
      {{text}}
    </div>
  </div>
</template>

<style scoped>
  .circle {
    position: relative;
    border-radius: 50%;
  }

  .clip-left, .clip-right {
    top: auto;
    left: auto;
    position: absolute;
  }

  .circle-left, .circle-right {
    top: auto;
    left: auto;
    position: absolute;
    border-radius: 50%;
  }

  .mask {
    font-weight: bold;
    border-radius: 50%;
    background: #ffffff;
    position: absolute;
    text-align: center;
  }
</style>
